import $ from "jquery";
$(document).ready(function () {
    if ($('.page-template-tpl-reservation').length) {
        $('form').on("click", '.submit-reservation .Button', function (e) {
            // e.preventDefault();
        });
    }
});
